<template>
  <div>
    <div :class="['header', { 'active': isActive || !isHome }]">
      <div class="header-btn" @click="isShow = true"></div>
      <div class="header-logo" @click="jump('/')"></div>
    </div>

    <div :class="['menu', { 'menu-opne': isShow }]">
      <div class="menu-mask" @click="isShow = false"></div>
      <ul class="menu-content">
        <div class="menu-close" @click="isShow = false"></div>
        <li :class="['menu-item', { 'menu-item-open': openIndex === index }]" v-for="(menu, index) in menus" :key="index">
          <div class="menu-item-text" @click="open(menu, index)">
            <div>{{menu.name}}</div>
            <div class="menu-item-arrow" v-if="menu.children"></div>
          </div>
          <ul class="menu-item-sub">
            <li class="menu-item-text" v-for="(child, cIndex) in menu.children" :key="cIndex" @click="jump(child.path)">
              {{child.name}}
            </li>
          </ul>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'layout-header',
  props: {
    isHome: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      isShow: false,
      menus: [
        { name: '首页', path: '/' },
        { name: '产品及服务', path: '', children: [
          { name: '建筑机器人', path: '/robot-list' },
          { name: '数字科技', path: '/digi-tech' },
          { name: '新型建筑工业化', path:  '/new-build'},
          { name: '智慧施工', path: '/build' },
          { name: '下载中心', path: '/download' }
        ] },
        { name: '联系我们', path: '/contact-index' },
        { name: '校园招聘', path: 'https://bdr2022.zhiye.com/home' },
      ],
      openIndex: 1,
      isActive: false
    };
  },
  watch: {
    isShow (val) {
      document.body.style.overflow = val ? 'hidden' : 'auto';
    }
  },
  created () {
    window.addEventListener('scroll', this.handleScroll)
  },
  methods: {
    handleScroll () {
      if (this.isHome) {
        const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
        this.isActive = scrollTop > 10;
      }
    },
    open ({ children = [], path }, index) {
      let reUrl = /(http|https):\/\/([\w.]+\/?)\S*/
      if (reUrl.test(path) === true) {
        window.open(path, "_blank")
        return false;
      }

      if (children.length > 0) {
        this.openIndex = index === this.openIndex ? -1 : index;
      } else {
        this.jump(path)
      }
    },
    jump (path) {
      this.isShow = false;
      if (path && path !== this.$route.path) {
        // this.openIndex = -1;
        this.$router.push(path);
      }
    }
  }
};
</script>
<style lang='less' scoped>
.header {
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  width: 100vw;
  height: 112px;
  flex-direction: row;
  align-items: center;
  z-index: 9;
  background: linear-gradient(180deg,rgba(0,0,0,0.60), rgba(0,0,0,0.00));
  &-btn {
    position: absolute;
    top: 33px;
    left: 40px;
    width: 48px;
    height: 48px;
    z-index: 10;
    transition: all 0.3s ease-out;
  }
  &-logo {
    width: 100%;
    height: 100%;
    transition: all 0.3s ease-out;
  }
  &:not(.active) {
    .header-logo {
      background: url("~@/assets/images/logo.png") center center transparent no-repeat;
      background-size: 224px 64px;
    }
    .header-btn {
      background: url("~@/assets/images/icon_menu.png") no-repeat;
      background-size: 100% 100%;
    }
  }
  &.active {
    .header-logo {
      background: url("~@/assets/images/logo-pink.png") center center#fff no-repeat;
      background-size: 224px 64px;
    }
    .header-btn {
      background: url("~@/assets/images/icon_menu_gray.png") no-repeat;
      background-size: 100% 100%;
    }
  }
}
.menu {
  &-mask {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: rgb(0, 0, 0);
    transition: all 0.3s ease-out;
  }
  &-content {
    position: fixed;
    top: 0;
    width: 450px;
    height: 100vh;
    padding-top: 96px;
    z-index: 99;
    background-color: #fff;
    transition: all 0.4s ease-out;
  }
  &-close {
    position: absolute;
    top: 33px;
    left: 40px;
    width: 42px;
    height: 42px;
    background: url("~@/assets/images/icon_close.png") no-repeat;
    background-size: 100% 100%;
  }
  &-item {
    &-text {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      height: 104px;
      line-height: 104px;
      padding: 0 40px 0 116px;
      font-size: 32px;
      font-weight: 400;
      color: #333;
    }
    &-arrow {
      width: 36px;
      height: 36px;
      background: url("~@/assets/images/icon_arrow.png") no-repeat;
      background-size: 100% 100%;
      transform: rotate(0deg);
      transition: transform 0.3s ease-out;
    }
    &-sub {
      visibility: hidden;
      .menu-item-text {
        font-size: 28px;
        height: 0;
        opacity: 0;
        transition: all 0.3s ease-out;
      }
    }
    &-open {
      .menu-item-arrow {
        transform: rotate(180deg);
      }
      .menu-item-sub {
        visibility: visible;
        .menu-item-text {
          opacity: 1;
          height: 88px;
        }
      }
    }
  }
  &:not(.menu-open) {
    .menu-content {
      left: -520px;
      overflow-y: scroll;
    }
    .menu-mask {
      opacity: 0;
      z-index: -1;
    }
  }
  &.menu-opne {
    .menu-content {
      left: 0;
       overflow-y: scroll;
    }
    .menu-mask {
      opacity: 0.5;
      z-index: 20;
    }
  }
}
</style>
